"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onBlockLoaded = onBlockLoaded;
const lib_1 = require("./lib");
/**
 * This function listens for matching blocks and element being added to and (optionally) removed from the page.
 * It applies the "js-ready" class to elements that have been set up.
 *
 * @param blockOrClassName Either the full block name (i.e. plaudit/accordion-group) or an CSS class name
 * @param onAdd the function to call when the named block (or element with the provided class name) is added to the page. This function should only process the element passed to it.
 * @param onRemove an optional function to call when a matching element is removed. It should only apply to the element being removed.
 */
function onBlockLoaded(blockOrClassName, onAdd, onRemove) {
    (0, lib_1.onDocumentLoaded)(() => {
        // WordPress core blocks don't include "core-" in the class name, so we remove it
        const className = blockOrClassName.includes("/")
            ? `wp-block-${(0, lib_1.kebabCase)(blockOrClassName.startsWith("core/") ? blockOrClassName.substring(5) : blockOrClassName)}`
            : blockOrClassName;
        for (const e of document.querySelectorAll(`.${className}:not(.js-ready)`)) {
            onAdd(e);
        }
        new MutationObserver(mutations => {
            for (const mutation of mutations) {
                for (const addedNode of mutation.addedNodes) {
                    if (addedNode instanceof HTMLElement) {
                        if (addedNode.classList.contains(className) && !addedNode.classList.contains("js-ready")) {
                            addedNode.classList.toggle("js-ready", true);
                            onAdd(addedNode);
                        }
                        for (const e of addedNode.querySelectorAll(`.${className}:not(.js-ready)`)) {
                            e.classList.toggle("js-ready", true);
                            onAdd(e);
                        }
                    }
                }
                if (onRemove) {
                    for (const removedNode of mutation.removedNodes) {
                        if (removedNode instanceof HTMLElement) {
                            if (removedNode.classList.contains(className) && removedNode.classList.contains("js-ready")) {
                                onRemove(removedNode);
                                removedNode.classList.remove("js-ready");
                            }
                            for (const e of removedNode.querySelectorAll(`.${className}.js-ready`)) {
                                onRemove(e);
                                e.classList.remove("js-ready");
                            }
                        }
                    }
                }
            }
        }).observe(document.querySelector(".wp-site-blocks") ?? document.body, { subtree: true, childList: true });
    });
}
//# sourceMappingURL=block-helpers.js.map